import Phaser from 'phaser'

const MAX_ZOOM = 1.5;
const MIN_ZOOM = 0.75;

export default class PinchZoomContainer extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene)
    {
        super(scene);

        this.touch1 = null;
        this.touchID1 = 0;
        this.touch2 = null;
        this.touchID2 = 0;

        this.background = this.scene.add.rectangle(0, 0, this.scene.scale.width, this.scene.scale.height, 0xffffff).setOrigin(0);
        this.add(this.background);
        this.background.alpha = 0;

        this.backgroundShape = this.scene.add.container((this.scene.scale.width / 2 - 102) - 409, (this.scene.scale.height / 2 - 76) - 307 ).setSize(this.scene.scale.width, this.scene.scale.height);
        this.add(this.backgroundShape);

        this.bs = this.scene.add.rectangle(0, 0, this.scene.scale.width, this.scene.scale.height, 0xffffff).setOrigin(0);
        this.backgroundShape.add(this.bs);
        this.bs.alpha = 0.01;

        this.setInteractive(new Phaser.Geom.Rectangle(0, 0, this.scene.scale.width, this.scene.scale.height), Phaser.Geom.Rectangle.Contains);

        this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer) =>
        {
            if (this.touch1 == null && this.touchID1 == 0)
            {
                this.touchID1 = pointer.id;
                let globalToLocal = this.getLocalPoint(pointer.x, pointer.y);
                this.touch1 = new Phaser.Geom.Point(globalToLocal.x, globalToLocal.y);
                return;
            }

            if (this.touch2 == null && this.touchID2 == 0)
            {
                this.touchID2 = pointer.id;
                let globalToLocal = this.getLocalPoint(pointer.x, pointer.y);
                this.touch2 = new Phaser.Geom.Point(globalToLocal.x, globalToLocal.y);
                return;
            }
        });

        this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, (pointer) =>
        {
            // important to null out this value to prevent 'jumps' in scaling
            this.oldDistance = null;

            if (this.touchID1 == pointer.id)
            {
                //touch 1 or mouse
                this.touch1 = null;
                this.touchID1 = 0;

            }
            else if (this.touchID2 == pointer.id)
            {
                //touch 2
                this.touch2 = null;
                this.touchID2 = 0;
            }
        });

        this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_MOVE, (pointer) =>
        {
            //only want to process if we have both touches
            if (this.touch1 == null || this.touch2 == null)
            {
                return;
            }

            let touch = null;

            if (pointer.id == this.touchID1)
            {
                touch = this.touch1;
            }
            else if (pointer.id == this.touchID2)
            {
                touch = this.touch2;
            }

            if (touch == null) return;

            let globalToLocal = this.getLocalPoint(pointer.x, pointer.y);
            let dX = globalToLocal.x - touch.x;
            let dY = globalToLocal.y - touch.y;

            let dist = 0;

            if (evt.pointerID == this.touchID1)
            {
                dist = Phaser.Math.Distance.BetweenPoints(touch, this.touch2);
            }
            else if (evt.pointerID == this.touchID2)
            {
                dist = Phaser.Math.Distance.BetweenPoints(touch, this.touch1);
            }

            if (this.touch1 && this.touch2)
            {
                if (this.oldDistance == null)
                {
                    this.oldDistance = dist;
                }

                let zoomFraction = dist / this.oldDistance;
                this.oldDistance = dist;

                // to prevent 'jumping' of image, lets make dragging of image only respond to touch1
                this.zoomMap(zoomFraction, new Phaser.Geom.Point(dX / 2, dY / 2));
            }

            //finally we have moved the touch, reset it to current touch point
            if (touch == this.touch1)
            {
                let globalToLocal = this.getLocalPoint(pointer.x, pointer.y);
                this.touch1 = new Phaser.Geom.Point(globalToLocal.x, globalToLocal.y);
            }
            else if (touch == this.touch2)
            {
                let globalToLocal = this.getLocalPoint(pointer.x, pointer.y);
                this.touch2 = new Phaser.Geom.Point(globalToLocal.x, globalToLocal.y);
            }
        });
    }

    zoomMap(zoomFraction, zoomOffset)
    {
        let totalZoom = this.backgroundShape.scaleX * zoomFraction;
        if (totalZoom > MAX_ZOOM)
        {
            totalZoom = MAX_ZOOM;
        }

        if (totalZoom < MIN_ZOOM)
        {
            totalZoom = MIN_ZOOM;
        }

        this.backgroundShape.scale = totalZoom;

        this.backgroundShape.x += zoomOffset.x;
        this.backgroundShape.y += zoomOffset.y;
    }

    removeIt(obj)
    {
        this.backgroundShape.remove(obj, true);
    }

    addIt(obj)
    {
        this.backgroundShape.add(obj);
    }
}